<div class="card" [ngClass]="cssClass">
  @if (caption) {
    <div class="card-header">
      @if (icon) {
        <i class="{{icon}}"></i>
      }
      <h5 class="card-header-text">{{caption}}</h5>
    </div>
  }
  <div class="card-block" [ngClass]="cssBody">
    <ng-content></ng-content>
  </div>
  @if (footer) {
    <div class="card-footer">
      <ng-template [ngTemplateOutlet]="footer"></ng-template>
    </div>
  }
</div>
